import type { ChecklistItem } from '@tailorcast/shared-types';

interface ChecklistItemViewProps {
  item: ChecklistItem;
  isSeo?: boolean;
}

export function ChecklistItemView({ item, isSeo }: ChecklistItemViewProps) {
  const icon = item.status === 'pass' ? 'text-green-500' : 'text-red-500';
  const symbol = item.status === 'pass' ? '\u2713' : '\u2717';

  return (
    <div className="flex items-start gap-2 text-xs">
      <span className={`${icon} font-bold flex-shrink-0`}>{symbol}</span>
      <div>
        <span className="text-gray-700">{item.text}</span>
        {item.action && !isSeo && <span className="text-gray-400 ml-1">— {item.action}</span>}
        {item.action && isSeo && item.status === 'fail' && (
          <p className="text-amber-700 mt-0.5">{item.action}</p>
        )}
        {item.action && isSeo && item.status === 'pass' && (
          <span className="text-gray-400 ml-1">— {item.action}</span>
        )}
      </div>
    </div>
  );
}
